import styled from '@emotion/styled'
import type { FC, PropsWithChildren } from 'react'
import type { Asset } from 'contentful'

import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

interface HeroProps {
  heading?: string
  description?: string
  image?: Asset
}

const Hero: FC<PropsWithChildren<HeroProps>> = ({ heading, description, image }) => {
  return (
    <Wrapper>
      <HeroBase variant="2Col">
        <HeroRecipe.Copy>
          <CopyTextBase>
            {heading && (
              <CopyText.Heading variant="h1" tag="h1">
                {heading}
              </CopyText.Heading>
            )}
            {description && (
              <CopyText.Description variant="pExtraLarge" tag="p">
                {description}
              </CopyText.Description>
            )}
          </CopyTextBase>
        </HeroRecipe.Copy>

        <HeroRecipe.Contents>
          {image && (
            <picture>
              <StyledHeroRecipeImage
                src={`${image.fields.file.url}?w=832`}
                width={image.fields.file.details.image?.width}
                height={image.fields.file.details.image?.height}
                alt={image.fields.title}
                loading="lazy"
              />
            </picture>
          )}
        </HeroRecipe.Contents>
      </HeroBase>
    </Wrapper>
  )
}

const StyledHeroRecipeImage = styled(HeroRecipe.Image)`
  border-radius: 10px;
`

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.palette.twilio.gray[10]};
`

export default Hero
